export default __webpack_public_path__ + "static/media/Beam - Vision (1) (1).afc3ce34.pdf";